export const FormFieldDefinitions = require('../../../constants/form-field-definitions.json');
export const FormTypeGenerateKey = "formTypeGenerateKey";
export const FormTypeDownloadKey = "formTypeDownloadKey";
export const FormTypeActivateKey = "formTypeActivateKey";
export const FormTypeRetireKey = "formTypeRetireKey";
export const FormTypeUnRetireKey = "formTypeUnRetireKey";